export default "__VITE_ASSET__BC5A06XR__"